import React, { useState } from "react";
import "./Survey.css";
import { useFormData } from "../../../context/FormContext";
import { useUUIDData } from "../../../context/UUIDContext";

function Survey() {
  const { formData } = useFormData();
  const { setUUID } = useUUIDData();
  const [deliveryMode, setDeliveryMode] = useState("self");
  const [deliveryDay, setDeliveryDay] = useState(null);
  const [deliveryHour, setDeliveryHour] = useState(null);
  const [anonym, setAnonym] = useState("anonym");
  const [phone, setPhone] = useState("");
  const urlLink = process.env.REACT_APP_API_URL;

  const formatPhone = (digits) => {
    const cleaned = digits.replace(/\D/g, "").slice(0, 10); // faqat 10 ta raqam
    const part1 = cleaned.slice(0, 3);
    const part2 = cleaned.slice(3, 6);
    const part3 = cleaned.slice(6, 8);
    const part4 = cleaned.slice(8, 10);

    let formatted = "";
    if (part1) formatted += `(${part1}`;
    if (part1.length === 3) formatted += `) `;
    if (part2) formatted += part2;
    if (part2.length === 3) formatted += `-`;
    if (part3) formatted += part3;
    if (part3.length === 2) formatted += `-`;
    if (part4) formatted += part4;

    return formatted;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "").replace(/^7/, ""); // remove +7 if user types it
    setPhone(formatPhone(digits));
  };

  let day = ["завтра", "послезавтра", "в любое время"];
  let hour = ["12:00 - 16:00", "16:00 - 20:00", "20:00 - 01:00"];

  const handleSubmit = (e) => {
    e.preventDefault();

    const flower_type = formData?.selectedBouquets || [];
    const flower_colour = formData?.selectedColors || [];

    const chosen_flowers = Object.entries(formData.ratings).map(
      ([flowerId, text]) => ({
        flower: Number(flowerId),
        text,
      })
    );

    const name = formData?.name;

    // Faqat self delivery holatida inputlardan qiymat olish
    const city =
      deliveryMode === "self"
        ? document.getElementById("city")?.value.trim() || ""
        : null;
    const street =
      deliveryMode === "self"
        ? document.getElementById("street")?.value.trim() || ""
        : null;
    const building =
      deliveryMode === "self"
        ? document.getElementById("house")?.value.trim() || ""
        : null;
    const corpus =
      deliveryMode === "self"
        ? document.getElementById("building")?.value.trim() || ""
        : null;
    const flat =
      deliveryMode === "self"
        ? document.getElementById("apartment")?.value.trim() || ""
        : null;
    const phone_number =
      deliveryMode === "self"
        ? document.getElementById("phone")?.value.trim() || ""
        : null;
    const message =
      deliveryMode === "self"
        ? document.getElementById("textarea")?.value.trim() || ""
        : null;
    const time =
      deliveryMode === "self" && deliveryDay && deliveryHour
        ? `${deliveryDay}, ${deliveryHour}`
        : "";
    const is_anonymous = deliveryMode === "self" && anonym === "anonym";

    const visits = 0;

    if (deliveryMode === "self") {
      if (!formData.name) return alert("Пожалуйста, введите имя.");
      if (!city) return alert("Пожалуйста, введите город.");
      if (!street) return alert("Пожалуйста, введите улицу.");
      if (!building) return alert("Пожалуйста, введите номер дома.");
      if (!phone_number) return alert("Пожалуйста, введите номер телефона.");
      if (!deliveryDay) return alert("Пожалуйста, выберите день доставки.");
      if (!deliveryHour) return alert("Пожалуйста, выберите время доставки.");
      const onlyDigits = phone_number.replace(/\D/g, ""); // Faqat raqamlar
      if (onlyDigits.length !== 11) {
        return alert("Пожалуйста, введите полный номер телефона (11 цифр).");
      }
    }

    // Formni dinamik yig'ish
    const payload = {
      flower_type,
      flower_colour,
      chosen_flowers,
      name,
      address_mentioned: false,
      ...(deliveryMode === "self" && {
        city,
        street,
        building,
        corpus,
        flat,
        phone_number,
        message,
        time,
        is_anonymous,
        address_mentioned: true,
        visits,
      }),
    };

    fetch(`${urlLink}api/saved-data/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.message || "Ошибка при отправке данных.");
        }

        if (data.uuid) {
          setUUID(data.uuid);
        }

        alert("Успешно отправлено!");

        if (deliveryMode === "self") {
          document.getElementById("city").value = "";
          document.getElementById("street").value = "";
          document.getElementById("house").value = "";
          document.getElementById("building").value = "";
          document.getElementById("apartment").value = "";
          document.getElementById("phone").value = "";
          document.getElementById("textarea").value = "";
          setDeliveryDay(null);
          setDeliveryHour(null);
        }
      })
      .catch((err) => {
        console.error("❌ Error:", err);
        alert(err.message || "Ошибка при отправке формы.");
      });
  };

  return (
    <div className="survey">
      <div className="container">
        <div className="survey__container">
          <h3 className="survey__header">уточним...?</h3>

          <form className="survey__form">
            <div className="survey__tab-switch">
              <button
                className={
                  deliveryMode === "self"
                    ? "survey__active"
                    : "survey__deactive"
                }
                onClick={(e) => {
                  e.preventDefault();
                  setDeliveryMode("self");
                }}
              >
                введу сама
              </button>
              <button
                className={
                  deliveryMode === "he" ? "survey__active" : "survey__deactive"
                }
                onClick={(e) => {
                  e.preventDefault();
                  setDeliveryMode("he");
                }}
              >
                он знает (спросить)
              </button>
            </div>

            {deliveryMode === "self" && (
              <div className="survey__wrapper">
                {/* Город */}
                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="city">
                    город
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    className="survey__input"
                  />
                </div>

                {/* Улица */}
                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="street">
                    улица
                  </label>
                  <input
                    type="text"
                    id="street"
                    name="street"
                    className="survey__input"
                  />
                </div>

                {/* Дом, корпус, квартира */}
                <div className="survey__row">
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="house">
                      дом
                    </label>
                    <input
                      type="text"
                      id="house"
                      name="house"
                      className="survey__input"
                    />
                  </div>
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="building">
                      корпус
                    </label>
                    <input
                      type="text"
                      id="building"
                      name="building"
                      className="survey__input"
                    />
                  </div>
                  <div className="survey__form-group">
                    <label className="survey__label" htmlFor="apartment">
                      квартира
                    </label>
                    <input
                      type="text"
                      id="apartment"
                      name="apartment"
                      className="survey__input"
                    />
                  </div>
                </div>

                {/* Телефон */}
                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="phone">
                    номер телефона
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="survey__input"
                    value={"+7 " + phone}
                    onChange={handleChange}
                  />
                </div>

                {/* Дата доставки */}
                <div className="survey__day-options">
                  {day.map((opt) => (
                    <button
                      key={opt}
                      className={`survey__day-btn ${
                        deliveryDay === opt ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setDeliveryDay(opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>

                <div className="survey__form-group">
                  <label className="survey__label" htmlFor="textarea">
                    что то написать нам
                  </label>
                  <textarea
                    id="textarea"
                    name="textarea"
                    className="survey__input"
                  />
                </div>

                <div className="survey__hour-options">
                  {hour.map((opt) => (
                    <button
                      key={opt}
                      className={`survey__hour-btn ${
                        deliveryHour === opt ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setDeliveryHour(opt);
                      }}
                    >
                      {opt}
                    </button>
                  ))}
                </div>

                <div className="survey__tab-switch">
                  <button
                    className={
                      anonym === "anonym"
                        ? "survey__active"
                        : "survey__deactive"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setAnonym("anonym");
                    }}
                  >
                    скрыть адрес от него (анонимно)*
                  </button>
                  <button
                    className={
                      anonym === "unanonym"
                        ? "survey__active"
                        : "survey__deactive"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setAnonym("unanonym");
                    }}
                  >
                    я не против показать ему свой адрес
                  </button>
                </div>
                <p className="survey__subtext">
                  *все данные кроме имени будем знать только мы
                </p>
              </div>
            )}

            <div className="survey__btn-wrapper">
              <button className="survey__submit-btn" onClick={handleSubmit}>
                Создать ссылку
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Survey;
